import { render, staticRenderFns } from "./drugcontact.vue?vue&type=template&id=1f708882&"
import script from "./drugcontact.vue?vue&type=script&lang=js&"
export * from "./drugcontact.vue?vue&type=script&lang=js&"
import style0 from "./drugcontact.vue?vue&type=style&index=0&id=1f708882&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports